module.exports = __webpack_public_path__ + "img/download.d6c33229.svg";